// extracted by mini-css-extract-plugin
export default {"titleContainer":"NewlyPublishedArticlesContainer_titleContainer__26xos"};